<template>
  <!-- eslint-disable -->
  <div>
    <b-overlay variant="white" :show="showLoading" spinner-variant="primary" blur="0" opacity=".75" rounded="sm">
      <tipo-entrada-filters ref="filters" />
      <b-card no-body class="mb-0">
        <b-table
          class="position-relative"
          :hover="true"
          :items="records"
          responsive
          :fields="fields"
          show-empty
          empty-text="No existen"
          @sort-changed="sortChanged"
        >
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <b-button size="sm" class="" @click.prevent="edit(data.item)" v-b-tooltip.hover.top="'Editar'" variant="flat-success">
              <feather-icon icon="Edit2Icon" />
            </b-button>
            <b-button size="sm" class="" v-b-tooltip.hover.top="'Eliminar'" variant="flat-danger">
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col sm="3">
              <b-form-group label-cols="4" label-cols-md="4" label-size="md" label="Entradas" label-for="input-md">
                <b-form-select
                  v-model="showEntrie"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="entries"
                  @change="changeSizePage"
                />
              </b-form-group>
            </b-col>
            <b-col sm="3" class="mt-75" style="font-size: 12px">
              <span> {{ totalElements }} Registros en total</span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalElements"
                :per-page="showEntrie"
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @change="cambioPagina"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import tipoEntradaFilters from './tipoEntradaFilters.vue'
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple
  },
  data(){
    return{
      showLoading: false,
      records: [
        {
          id: 1,
          nombre: 'Boleta'
        },
        {
          id: 2,
          nombre: 'Factura'
        }
      ],
      fields: [
        //{ key: 'id', label: 'Nº', sortable: false },
        { key: 'nombre', label: 'Nombre', sortable: false },
        { key: 'actions', label: 'Acciones' }
      ],
      arrayFilters: [],
      currentPage: 1,
      entries: [10, 20, 50, 100],
      showEntrie: 10,
      totalElements: 0,
      id: 0,
      sort: 'id',
      order: 'desc',
    }
  },
  components:{
    tipoEntradaFilters
  },
  methods:{
    cambioPagina(e) {
      this.currentPage = e
    },
    changeSizePage() {
    },
    sortChanged(data) {
      this.sort = data.sortBy
      if (data.sortDesc) {
        this.order = 'desc'
      } else this.order = 'asc'
    },
    edit(item){
      console.log('item',item)
      this.$refs.filters.isAdd = true
      this.$refs.filters.$children[0].getData(item)
      console.log('this.$refs.filters', this.$refs.filters)
    }
  }
}
</script>

<style>

</style>
